import { Cloneable } from './Cloneable.js';
import { TCModelError } from './errors/index.js';
import { GVL } from './GVL.js';
import { PurposeRestrictionVector, Vector } from './model/index.js';
export class TCModel extends Cloneable {
    /**
 *
 */
    static consentLanguages = GVL.consentLanguages;
    isServiceSpecific_ = false;
    supportOOB_ = true;
    useNonStandardTexts_ = false;
    purposeOneTreatment_ = false;
    publisherCountryCode_ = 'AA';
    version_ = 2;
    consentScreen_ = 0;
    policyVersion_ = 5;
    consentLanguage_ = 'EN';
    cmpId_ = 0;
    cmpVersion_ = 0;
    vendorListVersion_ = 0;
    numCustomPurposes_ = 0;
    /*                      */
    gvl_;
    created;
    lastUpdated;
    /**
 *
 *
 *
 *
 */
    specialFeatureOptins = new Vector();
    /**
 *
 *
 *
 */
    purposeConsents = new Vector();
    /**
 *
 *
 *
 */
    purposeLegitimateInterests = new Vector();
    /**
 *
 *
 *
 */
    publisherConsents = new Vector();
    /**
 *
 *
 *
 */
    publisherLegitimateInterests = new Vector();
    /**
 *
 *
 *
 */
    publisherCustomConsents = new Vector();
    /**
 *
 *
 *
 */
    publisherCustomLegitimateInterests = new Vector();
    /**
 *
 *
 */
    customPurposes;
    /**
 *
 *
 */
    vendorConsents = new Vector();
    /**
 *
 *
 *
 */
    vendorLegitimateInterests = new Vector();
    /**
 *
 *
 *
 *
 *
 *
 *
 *
 */
    vendorsDisclosed = new Vector();
    /**
 *
 */
    vendorsAllowed = new Vector();
    publisherRestrictions = new PurposeRestrictionVector();
    /**
 *
 *
 *
 *
 *
 */
    constructor(gvl) {
        super();
        if (gvl) {
            this.gvl = gvl;
        }
        this.updated();
    }
    /**
 *
 *
 */
    set gvl(gvl) {
        /**
 *
 */
        if (!(GVL.isInstanceOf(gvl))) {
            gvl = new GVL(gvl);
        }
        this.gvl_ = gvl;
        this.publisherRestrictions.gvl = gvl;
    }
    /**
 *
 */
    get gvl() {
        return this.gvl_;
    }
    /**
 *
 *
 *
 *
 */
    set cmpId(integer) {
        integer = Number(integer);
        if (Number.isInteger(integer) && integer > 1) {
            this.cmpId_ = integer;
        }
        else {
            throw new TCModelError('cmpId', integer);
        }
    }
    get cmpId() {
        return this.cmpId_;
    }
    /**
 *
 *
 *
 *
 *
 *
 *
 */
    set cmpVersion(integer) {
        integer = Number(integer);
        if (Number.isInteger(integer) && integer > -1) {
            this.cmpVersion_ = integer;
        }
        else {
            throw new TCModelError('cmpVersion', integer);
        }
    }
    get cmpVersion() {
        return this.cmpVersion_;
    }
    /**
 *
 *
 *
 *
 *
 *
 *
 *
 */
    set consentScreen(integer) {
        integer = Number(integer);
        if (Number.isInteger(integer) && integer > -1) {
            this.consentScreen_ = integer;
        }
        else {
            throw new TCModelError('consentScreen', integer);
        }
    }
    get consentScreen() {
        return this.consentScreen_;
    }
    /**
 *
 *
 *
 *
 *
 */
    set consentLanguage(lang) {
        this.consentLanguage_ = lang;
    }
    get consentLanguage() {
        return this.consentLanguage_;
    }
    /**
 *
 *
 *
 *
 *
 */
    set publisherCountryCode(countryCode) {
        if (/^([A-z]){2}$/.test(countryCode)) {
            this.publisherCountryCode_ = countryCode.toUpperCase();
        }
        else {
            throw new TCModelError('publisherCountryCode', countryCode);
        }
    }
    get publisherCountryCode() {
        return this.publisherCountryCode_;
    }
    /**
 *
 *
 *
 *
 *
 *
 */
    set vendorListVersion(integer) {
        /**
 *
 *
 *
 */
        integer = Number(integer) >> 0;
        if (integer < 0) {
            throw new TCModelError('vendorListVersion', integer);
        }
        else {
            this.vendorListVersion_ = integer;
        }
    }
    get vendorListVersion() {
        if (this.gvl) {
            return this.gvl.vendorListVersion;
        }
        else {
            return this.vendorListVersion_;
        }
    }
    /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
    set policyVersion(num) {
        this.policyVersion_ = parseInt(num, 10);
        if (this.policyVersion_ < 0) {
            throw new TCModelError('policyVersion', num);
        }
    }
    get policyVersion() {
        if (this.gvl) {
            return this.gvl.tcfPolicyVersion;
        }
        else {
            return this.policyVersion_;
        }
    }
    set version(num) {
        this.version_ = parseInt(num, 10);
    }
    get version() {
        return this.version_;
    }
    /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
    set isServiceSpecific(bool) {
        this.isServiceSpecific_ = bool;
    }
    get isServiceSpecific() {
        return this.isServiceSpecific_;
    }
    /**
 *
 *
 *
 *
 *
 *
 *
 */
    set useNonStandardTexts(bool) {
        this.useNonStandardTexts_ = bool;
    }
    get useNonStandardTexts() {
        return this.useNonStandardTexts_;
    }
    /**
 *
 *
 *
 *
 */
    set supportOOB(bool) {
        this.supportOOB_ = bool;
    }
    get supportOOB() {
        return this.supportOOB_;
    }
    /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
    set purposeOneTreatment(bool) {
        this.purposeOneTreatment_ = bool;
    }
    get purposeOneTreatment() {
        return this.purposeOneTreatment_;
    }
    /**
 *
 *
 *
 */
    setAllVendorConsents() {
        this.vendorConsents.set(this.gvl.vendors);
    }
    /**
 *
 *
 *
 */
    unsetAllVendorConsents() {
        this.vendorConsents.empty();
    }
    /**
 *
 *
 *
 */
    setAllVendorsDisclosed() {
        this.vendorsDisclosed.set(this.gvl.vendors);
    }
    /**
 *
 *
 *
 */
    unsetAllVendorsDisclosed() {
        this.vendorsDisclosed.empty();
    }
    /**
 *
 *
 *
 */
    setAllVendorsAllowed() {
        this.vendorsAllowed.set(this.gvl.vendors);
    }
    /**
 *
 *
 *
 */
    unsetAllVendorsAllowed() {
        this.vendorsAllowed.empty();
    }
    /**
 *
 *
 *
 */
    setAllVendorLegitimateInterests() {
        this.vendorLegitimateInterests.set(this.gvl.vendors);
    }
    /**
 *
 *
 *
 */
    unsetAllVendorLegitimateInterests() {
        this.vendorLegitimateInterests.empty();
    }
    /**
 *
 *
 *
 */
    setAllPurposeConsents() {
        this.purposeConsents.set(this.gvl.purposes);
    }
    /**
 *
 *
 *
 */
    unsetAllPurposeConsents() {
        this.purposeConsents.empty();
    }
    /**
 *
 *
 *
 */
    setAllPurposeLegitimateInterests() {
        this.purposeLegitimateInterests.set(this.gvl.purposes);
    }
    /**
 *
 *
 *
 */
    unsetAllPurposeLegitimateInterests() {
        this.purposeLegitimateInterests.empty();
    }
    /**
 *
 *
 *
 */
    setAllSpecialFeatureOptins() {
        this.specialFeatureOptins.set(this.gvl.specialFeatures);
    }
    /**
 *
 *
 *
 */
    unsetAllSpecialFeatureOptins() {
        this.specialFeatureOptins.empty();
    }
    setAll() {
        this.setAllVendorConsents();
        this.setAllPurposeLegitimateInterests();
        this.setAllSpecialFeatureOptins();
        this.setAllPurposeConsents();
        this.setAllVendorLegitimateInterests();
    }
    unsetAll() {
        this.unsetAllVendorConsents();
        this.unsetAllPurposeLegitimateInterests();
        this.unsetAllSpecialFeatureOptins();
        this.unsetAllPurposeConsents();
        this.unsetAllVendorLegitimateInterests();
    }
    get numCustomPurposes() {
        let len = this.numCustomPurposes_;
        if (typeof this.customPurposes === 'object') {
            /**
 *
 *
 *
 *
 *
 */
            const purposeIds = Object.keys(this.customPurposes)
                .sort((a, b) => Number(a) - Number(b));
            len = parseInt(purposeIds.pop(), 10);
        }
        return len;
    }
    set numCustomPurposes(num) {
        this.numCustomPurposes_ = parseInt(num, 10);
        if (this.numCustomPurposes_ < 0) {
            throw new TCModelError('numCustomPurposes', num);
        }
    }
    /**
 *
 *
 *
 */
    updated() {
        const date = new Date();
        const utcDate = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()));
        this.created = utcDate;
        this.lastUpdated = utcDate;
    }
}
